module.exports = __webpack_public_path__ + "img/FR16233.72d73323.png";